import ExampleComponent from './Example';

export default ExampleComponent;
